import HeadingItem from '@modules/utilities/interfaces/HeadingItem';
import { ScopeType } from '@rbx/clients/cloudAuthenticationService/v1';

export default function scopeHeadings(scopeTypes: ScopeType[]): HeadingItem[] {
  const headings: HeadingItem[] = [];

  if (scopeTypes && Array.isArray(scopeTypes)) {
    scopeTypes.forEach((scope) => {
      let firstOperation = '';
      if (Array.isArray(scope.operationOverrides) && scope.operationOverrides.length > 0) {
        firstOperation = scope.operationOverrides.map((op) => op.name).sort()[0] ?? 'read';
      }

      headings.push({
        title: scope.name ?? '',
        slug: `${scope.name}:${firstOperation}`,
        level: 2,
      });

      if (Array.isArray(scope.operationOverrides)) {
        scope.operationOverrides.forEach((operation) => {
          headings.push({
            title: operation.name ?? '',
            slug: `${scope.name}:${operation.name}`,
            level: 3,
            label: operation.name ?? '',
          });
        });
      }
    });

    headings.push({
      title: 'openid',
      slug: 'openid',
      level: 2,
    });
    headings.push({
      title: 'profile',
      slug: 'profile',
      level: 2,
    });
  }

  headings.sort((a, b) => a.slug.localeCompare(b.slug));

  return headings;
}
